var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignationChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "briefcase-fill",
    transform: "translate(14272 9109.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    "data-name": "Path 10426",
    d: "M0,26.008a2.813,2.813,0,0,0,2.813,2.813H27.188A2.813,2.813,0,0,0,30,26.008v-10.6L15.242,19.345a.937.937,0,0,1-.484,0L0,15.412Z",
    transform: "translate(0 -2.196)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M0,8.814A2.813,2.813,0,0,1,2.813,6H27.188A2.813,2.813,0,0,1,30,8.814v2.6L15.724,15.216a2.812,2.812,0,0,1-1.447,0L0,11.409ZM9.375,5.063A2.813,2.813,0,0,1,12.188,2.25h5.625a2.813,2.813,0,0,1,2.813,2.813V6H18.75V5.063a.938.938,0,0,0-.937-.938H12.188a.938.938,0,0,0-.937.938V6H9.375Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignationChange);
export default __webpack_public_path__ + "static/media/designation-change.595c76d3fa2f35e82370cbe5ef55b9e1.svg";
export { ForwardRef as ReactComponent };